///include /assets/js/app/p/checkout.js
class CheckoutTransfer extends CheckoutDriver {
    get supportsSelection() {
        return false
    }
}

CheckoutDriver.byName.transfer = CheckoutTransfer